import React from 'react';
import isNil from 'utils/isNil';
import StyledRichText from 'components/RichText/StyledRichText';
import EmbedCode from 'components/EmbedCode';
import usePodcastDetailContentSectionImages from 'hooks/usePodcastDetailContentSectionImages';
import SummarySection from 'components/SummarySection';
import Sidebar from 'components/Sidebar';
import AddThisSocialSharing from 'components/AddThisSocialSharing';
import { SectionContainer } from './styles';

const PodcastDetailContentSection = ({
  addThisLoaded,
  overview,
  episodeSections = [],
  summary,
  relatedVideos = [],
  moreEpisodes = [],
  sideBar,
  sideBarRecommended,
  pageUrl,
  ...otherProps
}) => {
  episodeSections = episodeSections || [];
  relatedVideos = relatedVideos || [];
  const pageImages = usePodcastDetailContentSectionImages();

  let podcastMore;
  let favSpotify, favPodcast, favGooglePodcast, favOrange, favSticher, favPandora, favFeed;
  pageImages.forEach(imageItem => {
    if (imageItem.node.internalName === 'podcast-detail-content-more') {
      podcastMore = !isNil(imageItem.node.image) ? imageItem.node.image.file.url : '';
    } else if (imageItem.node.internalName === 'podcast-favorite-spotify') {
      favSpotify = !isNil(imageItem.node.image) ? imageItem.node.image.file.url : '';
    } else if (imageItem.node.internalName === 'podcast-favorite-podcast') {
      favPodcast = !isNil(imageItem.node.image) ? imageItem.node.image.file.url : '';
    } else if (imageItem.node.internalName === 'podcast-favorite-google-podcast') {
      favGooglePodcast = !isNil(imageItem.node.image) ? imageItem.node.image.file.url : '';
    } else if (imageItem.node.internalName === 'podcast-favorite-orange') {
      favOrange = !isNil(imageItem.node.image) ? imageItem.node.image.file.url : '';
    } else if (imageItem.node.internalName === 'podcast-favorite-sticher') {
      favSticher = !isNil(imageItem.node.image) ? imageItem.node.image.file.url : '';
    } else if (imageItem.node.internalName === 'podcast-favorite-pandora') {
      favPandora = !isNil(imageItem.node.image) ? imageItem.node.image.file.url : '';
    } else if (imageItem.node.internalName === 'podcast-favorite-feed') {
      favFeed = !isNil(imageItem.node.image) ? imageItem.node.image.file.url : '';
    }
  });

  const otherPlatforms = [
    {
      title: 'Spotify',
      logo: favSpotify,
      link:
        otherProps.spotifyLink ||
        'https://open.spotify.com/show/76wMZ1SJV4OAql9HzbnQ87?si=66s37hbqRpu_4vQCaB1T3w',
    },
    {
      title: 'Podcast',
      logo: favPodcast,
      link:
        otherProps.applePodcastsLink ||
        'https://podcasts.apple.com/us/podcast/toolbox-for-the-trades/id1503078938',
    },
    {
      title: 'Google Podcast',
      logo: favGooglePodcast,
      link:
        otherProps.googlePodcastLink ||
        'https://podcasts.google.com/feed/aHR0cHM6Ly90b29sYm94Zm9ydGhldHJhZGVzLmxpYnN5bi5jb20vcnNz/episode/MGY3MzYyNjAtZWFiNy00OTdiLWE3ZmUtYzEyMjk1YzNkMjU0?ved=0CBEQzsICahcKEwigvfW3k7DpAhUAAAAAHQAAAAAQAQ',
    },
  ];

  const moreContents = [
    {
      img: podcastMore,
      title: 'This is a title of a featured content ',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      subtitle: 'Education • 21  minutes',
      link: '/',
    },
    {
      img: podcastMore,
      title: 'This is a title of a featured content ',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      subtitle: 'Education • 21  minutes',
      link: '/',
    },
  ];

  return (
    <SectionContainer {...otherProps}>
      <div className="section-podcast-detail-content--wrapper">
        <div className="section-podcast-detail-content--container">
          <AddThisSocialSharing placement="topLeftSticky" />
          <div className="section-podcast-detail-content--contents">
            <div className="section-podcast-detail-content--main-contents">
              <div className="section-podcast-detail-content--main-text-area">
                <div className="section-podcast-detail-content--overview-area">
                  <h2 className="section-podcast-detail-content--content-title">
                    Episode Overview
                  </h2>
                  <StyledRichText content={overview?.json} />
                </div>

                {episodeSections && episodeSections.length > 0 && (
                  <div className="section-podcast-detail-content--reference-area">
                    <h3>Key Takeaways</h3>
                    {episodeSections.map((section, index) => {
                      return (
                        <a
                          className="section-podcast-detail-content--reference"
                          href={`#${section.anchorId}`}
                          key={index}
                        >
                          {section.sectionTitle}
                        </a>
                      );
                    })}
                  </div>
                )}

                {episodeSections && episodeSections.length > 0 && (
                  <div className="section-podcast-detail-content--content-area">
                    {episodeSections.map((section, index) => {
                      return (
                        <div
                          className="section-podcast-detail-content--content-section-area"
                          id={`${section.anchorId}`}
                          key={index}
                        >
                          <StyledRichText content={section.content.json} />
                        </div>
                      );
                    })}
                  </div>
                )}

                {relatedVideos?.embedCode && (
                  <div className="section-podcast-detail-content--video-area">
                    <h2 className="section-podcast-detail-content--video-title">Related Videos</h2>
                    <EmbedCode
                      code={relatedVideos.embedCode?.json}
                      headCode={relatedVideos.headCode?.json}
                    />
                  </div>
                )}
              </div>
              {/* TODO: once Person content model is updated this can be reintroduced */}
              {false && (
                <div className="section-podcast-detail-content--more-area">
                  <h2 className="section-podcast-detail-content--more-title">
                    More content from John Doe
                  </h2>
                  {moreContents.map((item, index) => {
                    return (
                      <a className="section-podcast-detail-content--more-item" href={item.link}>
                        <img
                          className="section-podcast-detail-content--more-item-img"
                          src={item.img}
                        />
                        <div className="section-podcast-detail-content--more-item-text">
                          <p className="section-podcast-detail-content--more-item-title">
                            {item.title}
                          </p>
                          <p className="section-podcast-detail-content--more-item-description">
                            {item.description}
                          </p>
                          <p className="section-podcast-detail-content--more-item-subtitle">
                            {item.subtitle}
                          </p>
                        </div>
                      </a>
                    );
                  })}
                </div>
              )}

              <SummarySection
                className="test-summary-section"
                headline={summary?.headline}
                subHead={summary?.subhead}
                colorScheme={summary?.colorScheme}
                callToAction={summary?.callToAction[0]}
              />
            </div>

            <div className="section-podcast-detail-content--sidebar-contents">
              <Sidebar
                content={sideBar}
                relatedPosts={sideBarRecommended}
                hubType={'podcast'}
                otherPlatforms={otherPlatforms}
              />
            </div>
          </div>
        </div>
      </div>
    </SectionContainer>
  );
};

export default PodcastDetailContentSection;
